/* Frontend constants shared between layouts and module pages. */

export const MODULE_KEYS = {
  clientes: "clientes",
  agenda: "agenda",
  fidelidade: "fidelidade",
  automacoes: "automacoes",
  servicos: "servicos",
};

export const LOYALTY_TRIGGERS = [
  { v: "appointment.completed", l: "Atendimento concluído" },
  { v: "client.created", l: "Novo cliente cadastrado" },
  { v: "client.birthday", l: "Aniversário do cliente" },
  { v: "client.referral", l: "Indicação validada" },
  { v: "client.inactive_30d", l: "Cliente inativo há 30 dias" },
  { v: "sale.completed", l: "Venda concluída" },
  { v: "manual", l: "Manual" },
];

export const AUTO_TRIGGERS = [
  { v: "appointment.completed", l: "Atendimento concluído" },
  { v: "appointment.scheduled", l: "Atendimento agendado" },
  { v: "client.created", l: "Novo cliente" },
  { v: "client.birthday", l: "Aniversário" },
  { v: "client.inactive_30d", l: "Cliente inativo há 30 dias" },
  { v: "loyalty.threshold_reached", l: "Atingiu pontuação X" },
  { v: "manual", l: "Manual" },
];

export const AUTO_ACTIONS = [
  { v: "send_message", l: "Enviar mensagem" },
  { v: "award_points", l: "Premiar com pontos" },
  { v: "tag_client", l: "Marcar tag no cliente" },
  { v: "create_followup", l: "Criar follow-up" },
];

export const REWARD_KINDS = [
  { v: "discount", l: "Desconto" },
  { v: "service", l: "Serviço grátis" },
  { v: "product", l: "Produto" },
  { v: "freebie", l: "Brinde" },
  { v: "experience", l: "Experiência" },
];
